export const START_FETCH_DISTRICTS = 'START_FETCH_DISTRICTS';

export const SET_FETCHED_DISTRICTS = 'SET_FETCHED_DISTRICTS';

export const FETCH_DISTRICTS_ERROR = 'FETCH_DISTRICTS_ERROR';

export const SET_ICS_TYPE = 'SET_ICS_TYPE';
